// extracted by mini-css-extract-plugin
export default {"container":"style_container__9azcQ","valueContainer":"style_valueContainer__xHSAy","value":"style_value__Btypo","background":"style_background__dyq+r","text":"style_text__br1ri"};